exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-components-list{display:block}adp-components-list .components-list{padding-left:10px;font-size:14px;font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif}adp-components-list .components-list li a{display:block;padding:9px 18px;color:#1a8099;transition:color .3s ease}adp-components-list .components-list li a:hover{color:#0e5061;transition:color .3s ease}adp-components-list .components-list .icon{padding-left:5px;font-size:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpComponentsList/adpComponentsList.less
// module id = 480
// module chunks = 0